import { isAfter, isBefore, isExists, startOfDay } from 'date-fns';
import { formatDateStringToObject } from 'syf-js-utilities/formats';
import { getEndDateForPayment, getEstDateObject, getEstDateString, getMaximumPaymentDays } from '../../helpers';
import { t } from '../../strings/i18n';
import { required } from '../../xform';
const getDateError = (selectedDate, endDate, noOfAvailableDays) => {
    const currentDate = startOfDay(getEstDateObject(new Date()));
    if (isBefore(selectedDate, currentDate)) {
        return t('errors.pastDueDate');
    }
    if (isAfter(selectedDate, endDate)) {
        return noOfAvailableDays === 1
            ? t('errors.presentDueDate')
            : t('errors.futureDueDate', { noOfAvailableDays });
    }
    return null;
};
const isValidDateFormat = (date) => {
    const [year, month, day] = date.split('-').map(Number);
    return isExists(year, month - 1, day);
};
const validateDateRange = (accountSummary) => {
    const { billing: { daysDelinquent }, product } = accountSummary;
    const endDate = getEndDateForPayment(daysDelinquent, product);
    return (value) => {
        if (value === null || value === undefined || value === '') {
            return;
        }
        const paymentDateError = getDateError(formatDateStringToObject(value), endDate, getMaximumPaymentDays(daysDelinquent, product));
        if (paymentDateError) {
            throw new Error(paymentDateError);
        }
    };
};
export const PAYMENT_DATE_INPUT_NAME = 'paymentDate';
const paymentDateConfig = (apiMachineRef) => {
    const api = apiMachineRef.getSnapshot().context;
    const accountSummary = api.accountSummaryQueryResult.data;
    return [
        PAYMENT_DATE_INPUT_NAME,
        getEstDateString(new Date()),
        'ENABLED',
        [
            required(t('errors.paymentDate')),
            validateDateRange(accountSummary),
            (value) => {
                if (value === null || value === undefined || value === '') {
                    return;
                }
                if (!isValidDateFormat(value)) {
                    throw new Error(t('errors.invalidDateFormat'));
                }
            }
        ]
    ];
};
export default paymentDateConfig;
